import { useEffect } from "react";

export const useScrollLock = (lock: boolean = true) => {
  useEffect(() => {
    if (!lock) return;

    // Save current scroll position and original body styles
    const scrollY = window.scrollY || window.pageYOffset || 0;
    const originalPosition = document.body.style.position;
    const originalTop = document.body.style.top;
    const originalWidth = document.body.style.width;
    const originalOverflowY = document.body.style.overflowY;

    // Lock scroll
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";
    document.body.style.overflowY = "hidden";

    return () => {
      // Restore original styles
      document.body.style.position = originalPosition;
      document.body.style.top = originalTop;
      document.body.style.width = originalWidth;
      document.body.style.overflowY = originalOverflowY === "hidden" ? "auto" : originalOverflowY;
      window.scrollTo(0, scrollY);
    };
  }, [lock]);
};
